<div class="bonanza-modal bonanza-background">
	<div id="contentToConvert" class="bonanza-modal-content">
		<div>
			<div class="bonanza-img-container">
				<i *ngIf="!mobile" id="bonanza-icon" (click)="setClose()" nz-icon nzType="close-circle"
					class="close-bonanza-icon" nzTheme="fill"></i>
				<img class="bonanza-responsive-img " src="../../../../assets/images/bonanza.png" alt="" />
			</div>
		</div>
		<div class="bonanza-card card">
			<div>
				<span class="bonanza-text">Hello, <span class="bonanza-text text-bold">{{name}}.</span> </span>
			</div>
			<div class="m-t-24">
				<p class="bonanza-text">2021 has been our most successful year because of you!
					Everyday, you help people and families discover financial happiness by going the extra mile.</p>
			</div>
			<div class="m-t-16">
				<p class="bonanza-text">The results are out and this year alone:</p>
			</div>
			<div class="m-t-24">
				<span class="bonanza-text">You helped <span class="bonanza-text-large"> {{totalCustomer|number}}
					</span><span class="native-color">People</span> in your community move <span
						class="bonanza-text-large">₦ {{totalAmountMoved|currency}} </span><span
						class="native-color">across Nigeria</span>. </span>
			</div>
			<div class="m-t-24">
				<p class="bonanza-text">Helping just one person is beautiful,
					but helping <span style="font-weight:600">{{totalCustomer|number}}</span> people get easy access to
					financial services is amazing.</p>
			</div>
			<div class="m-t-16">
				<p class="bonanza-text">This is a reminder that we see your effort and appreciate you. Happy Customer
					Service Week!</p>
			</div>
			<div class="m-t-16">
				<p class="bonanza-text">Moniepoint HQ.</p>
			</div>
			<div class="m-t-79">
				<div *ngIf="!mobile" nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
					<div nz-col nzSpan="10">
						<span style="position:relative;top:-.7em">
							<span style="position:relative;top:-.8em"><img alt=""
									src="../../../../assets/images/powersveev.png" height="28" width="33" />
							</span>
							<span style="margin-left:20px">
								<svg fill="none" height="33" viewBox="0 0 1 33" width="1"
									xmlns="http://www.w3.org/2000/svg">
									<line stroke="#5D7F8D" stroke-linecap="round" x1="0.5" x2="0.500001" y1="0.5"
										y2="32.5" />
								</svg>
							</span>
							<span style="margin-left:12px;position:relative;top:-.8em">
								<img src="../../../../assets/images/csw.png" height="34" width="140" alt="" />
							</span>
						</span>
					</div>
					<div nz-col nzSpan="5">

					</div>
					<div id="controlButtons" nz-col nzSpan="9">
						<span>
							<span (click)="generatePDF()" class="bonanza-download-report-text">
								Download report
							</span>
							<span class="bonanza-separator">
								<svg fill="none" height="11" viewBox="0 0 1 11" width="1"
									xmlns="http://www.w3.org/2000/svg">
									<line stroke="#5D7F8D" stroke-linecap="round" x1="0.5" x2="0.5" y1="0.5"
										y2="10.5" />
								</svg>
							</span>
							<span (click)="setClose()" class="bonanza-close-text">
								Close
							</span>
						</span>
					</div>
				</div>
				<div id="controlButtonsMobile" *ngIf="mobile" nz-row>
					<div nz-col nzSpan="24">
						<span style="float:right">
							<span (click)="generatePDF(true)" class="bonanza-download-report-text">
								Download report
							</span>
							<span class="bonanza-separator">
								<svg fill="none" height="11" viewBox="0 0 1 11" width="1"
									xmlns="http://www.w3.org/2000/svg">
									<line stroke="#5D7F8D" stroke-linecap="round" x1="0.5" x2="0.5" y1="0.5"
										y2="10.5" />
								</svg>
							</span>
							<span (click)="setClose()" class="bonanza-close-text">
								Close
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>